/*
  ViewportImageExamples.tsx
  Works with:
  - React + Tailwind
  - Next.js + Tailwind (Next/Image section optional)
*/

import React from "react";

/* ===============================
   1. Viewport Height (20vh)
   Preserves original aspect ratio
================================ */
export const ViewportImageContain = ({
    src,
    alt = "",
}) => {
    return (
        <div className="h-[20vh] w-full flex items-center justify-center overflow-hidden bg-gray-100">
            <img
                src={src}
                alt={alt}
                className="h-full w-auto object-contain"
            />
        </div>
    );
};

/* ===============================
   2. Viewport Height + Fixed Ratio
   Consistent UI (16:9)
================================ */
export const ViewportImageAspect = ({
    src,
    alt = "",
}) => {
    return (
        <div className="h-[20vh] w-full aspect-[16/9] overflow-hidden bg-gray-100">
            <img
                src={src}
                alt={alt}
                className="h-full w-full object-contain"
            />
        </div>
    );
};

/* ===============================
   3. Responsive Viewport / Screen Aware
   Height adapts by viewport & width
================================ */
export const ViewportImageResponsive = ({
    src,
    alt = "",
}) => {
    return (
        <>
            <div
                className="
        w-full
        overflow-hidden
        bg-gray-100
        h-[16vh]
        sm:h-[18vh]
        md:h-[20vh]
        lg:h-[22vh]
        xl:h-[24vh]
        max-h-[280px]
        min-h-[120px]
        flex
        items-center
        justify-center
      "
            >
                <img
                    src={src}
                    alt={alt}
                    className="h-full w-auto object-contain"
                />
            </div>
            <div className="relative w-full aspect-[960/149]">
                <img
                    src={src}
                    alt="Breadcrumb background"
                    fill
                    priority
                    className="object-contain object-center"
                />
            </div>
        </>
    );
};

/* ===============================
   4. Next.js Optimized Image
   (Uncomment if using Next.js)
================================ */
// import Image from "next/image";

// export const ViewportImageNext = ({
//   src,
//   alt = "",
// }) => {
//   return (
//     <div className="relative h-[20vh] w-full bg-gray-100">
//       <Image
//         src={src}
//         alt={alt}
//         fill
//         className="object-contain"
//         priority
//       />
//     </div>
//   );
// };

/* ===============================
   Demo Page / Usage Example
================================ */
const ViewportImageExamples = () => {
    const imageUrl =
        "/assets/images/contact-us/contact-page-heading.1HoxVuc6.png";

    return (
        <div className="space-y-12 p-6">
            <section>
                <h2 className="mb-2 text-lg font-semibold">
                    20vh Image (Natural Aspect Ratio)
                </h2>
                <ViewportImageContain src={imageUrl} alt="Viewport contain" />
            </section>

            <section>
                <h2 className="mb-2 text-lg font-semibold">
                    20vh Image (Fixed 16:9 Aspect Ratio)
                </h2>
                <ViewportImageAspect src={imageUrl} alt="Viewport aspect" />
            </section>

            <section>
                <h2 className="mb-2 text-lg font-semibold">
                    Responsive Height (Viewport & Screen Aware)
                </h2>
                <ViewportImageResponsive
                    src={imageUrl}
                    alt="Viewport responsive"
                />
            </section>

            {/* Uncomment if using Next.js */}
            {/*
      <section>
        <h2 className="mb-2 text-lg font-semibold">
          20vh Image (Next.js Optimized)
        </h2>
        <ViewportImageNext src={imageUrl} alt="Viewport next image" />
      </section>
      */}
        </div>
    );
};

export default ViewportImageExamples;
